export class OrderDetailGarment
{
    constructor(
        public orderId: number,
        public orderDetailId:number,
        public garmentId: number,
        public orderPhaseId: number
    ){}
}


// WEBPACK FOOTER //
// ./src/app/+core/common/model/orderDetailGarment.model.ts